
$(document).on('ajax:success', '#search-for-matching-plans-form', event => {
  const [response, status, xhr] = event.detail;
  console.log("response", response);
  if (response.similar_plans.length > 0) {
    var list = $('#similar-plans');
    list.html("");
    for (var i = 0; i < response.similar_plans.length; i++) { 
      list.append("<li><a data-method='post' href='/admin/location_plans/" + response.location_plan.id + "/select_matched_plan?plan_id=" + response.similar_plans[i].id + "'>" + response.similar_plans[i].name + "</a></li>");
    }
  }
});